module.exports = __webpack_public_path__ + "static/media/001.c6dd2136.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/thumbs/001.jpg
// module id = 508
// module chunks = 0